import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageWrapper } from '@components/layout/page-wrapper';
import { useMediaAsset } from '@hooks/use-media-asset';
import { getBlogImageName } from '@config/media-mapping';
import {
  BlogsContainer,
  PageTitle,
  BlogGrid,
  BlogCard,
  BlogCardImage,
  BlogCardBody,
  BlogCardTitle,
} from './ai-blogs-home-page.styles';

interface BlogEntry {
  slug: string;
  title: string;
}

const BLOG_POSTS: BlogEntry[] = [
  {
    slug: 'ai-uneven-impact',
    title: "AI's Uneven Impact",
  },
];

const BlogCardWithImage: React.FC<{ post: BlogEntry }> = ({ post }) => {
  const navigate = useNavigate();
  const assetName = getBlogImageName(post.slug);
  const { url } = useMediaAsset(assetName);

  return (
    <BlogCard
      href={`/ai-blogs/${post.slug}`}
      onClick={(e) => {
        e.preventDefault();
        navigate(`/ai-blogs/${post.slug}`);
      }}
    >
      {url && <BlogCardImage $src={url} />}
      <BlogCardBody>
        <BlogCardTitle>{post.title}</BlogCardTitle>
      </BlogCardBody>
    </BlogCard>
  );
};

export const AIBlogsHomePage: React.FC = () => {
  return (
    <PageWrapper contained>
      <BlogsContainer>
        <PageTitle>AI Blogs</PageTitle>
        <BlogGrid>
          {BLOG_POSTS.map((post) => (
            <BlogCardWithImage key={post.slug} post={post} />
          ))}
        </BlogGrid>
      </BlogsContainer>
    </PageWrapper>
  );
};
